import { useCheckoutStateSelector } from "@checkout/context";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  PriceBreakdown as CorePriceBreakdown,
  type PriceBreakdownProps,
  getAdditionalFeesLineItem,
  getTripPriceLineItems,
} from "@hsbc/core-flights";
import { addAdditionalFeesToPriceLineItems } from "./priceBreakdownUtils";

export const PriceBreakdown = (props: PriceBreakdownProps) => {
  const { priceLineItems } = props;
  const { formatFiatCurrency } = useI18nContext();

  const additionalFees = useCheckoutStateSelector(getAdditionalFeesLineItem);
  const tripPriceLineItems = useCheckoutStateSelector(getTripPriceLineItems);

  const priceItemsWithAdditionalFees = addAdditionalFeesToPriceLineItems({
    priceLineItems,
    tripPriceLineItems,
    additionalFees,
    formatFiatCurrency,
  });

  return (
    <CorePriceBreakdown
      {...props}
      priceLineItems={priceItemsWithAdditionalFees}
    />
  );
};
